import { render, staticRenderFns } from "./detail-row.vue?vue&type=template&id=3ef92cf4"
import script from "./detail-row.vue?vue&type=script&lang=js"
export * from "./detail-row.vue?vue&type=script&lang=js"
import style0 from "./detail-row.vue?vue&type=style&index=0&id=3ef92cf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports